import { createSelector } from 'reselect';

import getShop from '@core/reducers/shop/selectors/getShop';

export const getPaymentProvidersByPartner = createSelector(getShop, shop =>
  shop?.paymentMethods
    ?.map(paymentMethod => paymentMethod?.paymentProvider)
    .filter(Boolean),
);
